module.exports = __webpack_public_path__ + "img/test2.fbc34bd6.jpeg";